// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCEVpJdtORwHam18S3JBSZm9mGA__G3_ZI",
  authDomain: "hisab-be04e.firebaseapp.com",
  projectId: "hisab-be04e",
  storageBucket: "hisab-be04e.firebasestorage.app",
  messagingSenderId: "1007341625589",
  appId: "1:1007341625589:web:7b76acac917353086865bc",
};

// Initialize Firebase
//const app = initializeApp(firebaseConfig);
initializeApp(firebaseConfig);
const db = getFirestore();
const auth = getAuth();
const storage = getStorage();

export { db, auth, storage };
